import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./CommonDashboard.css";
import {
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import {
  Button,
} from "@mui/material";
import { CssBaseline } from "@material-ui/core";
import TableStatus from "./TableStatus";



const theme = createMuiTheme({
  spacing: 5,
});



export const Tenant = ({
  errors, isLoading, 
  tenants: rows, 
  setSelectedTenantForEdit
}) => {
  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "domain",
      headerName: "Domain",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => setSelectedTenantForEdit(params?.row)}
        >
          Edit
        </Button>
      ),
    },
  ];


  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <div
              className="emms-data-grid-container"
              style={{ padding: "2.5% 10%", overflowX: "auto" }}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};